import SockJS from 'sockjs-client'
import Stomp from 'webstomp-client'
// import store from '@/store'
import { getToken } from '@/services/utils'
import { getEnvToHeader } from '@/config/interceptors/abEnv'
import { getApp } from '@/main'

// 根据cookie来判断当前是a环境还是b环境
const socketEnv = getEnvToHeader()

class SocketClass {
  constructor(param) {
    this.param = param // 初始化参数
    this.debug = false // 是否启用日志 默认启用
    this.reconnectId = 0 // 重试
    this.stompClient = {} // 客户端连接信息
    if (socketEnv) {
      this.SEND_ENDPOINT = `/websocket/${socketEnv}`
    } else {
      this.SEND_ENDPOINT = '/websocket'
    }
  }

  connect({ param = {}, successCb, errCb }) {
    this.param = param
    this.init(successCb, errCb)
  }

  init(successCb, errCb) {
    const VM = getApp()
    const socket = new SockJS(process.env.VUE_APP_BASE_API + this.SEND_ENDPOINT + '?token=' + encodeURIComponent(getToken().token) + '&env=' + VM.$ls.get('env'))
    this.stompClient = Stomp.over(socket)
    this.stompClient.hasDebug = this.debug
    this.stompClient.connect({ token: getToken().token }, source => {
      this.console('连接成功,信息如下 ↓')
      this.console(this.stompClient)
      successCb && successCb()
    }, err => {
      if (err) {
        this.console('连接失败,信息如下 ↓')
        this.console(err)
        errCb && errCb()
      }
    })
  }

  // 订阅
  sub(address, callBack) {
    if (!this.stompClient.connected) {
      this.console('没有连接,无法订阅')
      return
    }
    // 生成 id
    const timestamp = new Date().getTime() + address
    this.console('订阅成功 -> ' + address)
    this.stompClient.subscribe(address, message => {
      this.console(address + ' 订阅消息通知,信息如下 ↓')
      this.console(message)
      const data = JSON.parse(message.body)
      const headers = message.headers
      callBack(data, headers)
    }, {
      id: timestamp
    })
  }

  unSub(address) {
    if (!this.stompClient.connected) {
      this.console('没有连接,无法取消订阅 -> ' + address)
      return
    }
    let id = ''
    // eslint-disable-next-line no-unused-vars
    for (const item in this.stompClient.subscriptions) {
      if (item.endsWith(address)) {
        id = item
        break
      }
    }
    this.stompClient.unsubscribe(id)
    this.console('取消订阅成功 -> id:' + id + ' address:' + address)
  }

  // 断开连接
  disconnect(callBack) {
    clearInterval(this.reconnectId)
    if (!this.stompClient.connected) {
      this.console('没有连接,无法断开连接')
      return
    }
    this.stompClient.disconnect(() => {
      console.log('断开成功')
      if (callBack) {
        callBack()
      }
    })
  }

  // 单位 秒
  reconnect(time) {
    this.reconnectId = setInterval(() => {
      if (!this.stompClient.connected) {
        this.console('重新连接中...')
        this.init()
      }
    }, time * 1000)
  }

  console(msg) {
    if (this.debug) {
      console.log(msg)
    }
  }

  // 发送消息
  send(destination, msg, targetUser = 'server', header = {}) {
    const message = {}
    message.destination = destination
    message.content = msg
    message.targetUser = targetUser
    header.token = getToken().token
    this.stompClient.send(destination, JSON.stringify(message), header)
  }
}
export default SocketClass
